<template>
    <div>
        <table width="100%" class="vs-table vs-table--tbody-table ">
            <tr>
                <td class="td vs-table--td" style="padding: 5px">
                    SR No
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    : {{ form.sr_code ? this.form.sr_code : "" }}
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    Supplier Code
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    : {{ form.supplier_code }}
                </td>
            </tr>
            <tr>
                <td class="td vs-table--td" style="padding: 5px">
                    SR Type
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    : {{ Number(this.type) > 0 ? "Without Reference" : "With Reference" }}
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    Supplier Name
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    : {{ form.supplier_name }}
                </td>
            </tr>
            <tr>
                <td class="td vs-table--td" style="padding: 5px">
                    PO No
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    : {{ form.po_code }}
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    Supplier Address
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    : {{ form.supplier_address }}
                </td>
            </tr>
            <tr>
                <td class="td vs-table--td" style="padding: 5px">
                   Warehouse 
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    : {{ form.warehouse ? `${form.warehouse.code} - ${form.warehouse.name}`:""}}
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    Notes
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    : {{ form.note }}
                </td>
            </tr>
            <tr>
                <td class="td vs-table--td" style="padding: 5px">
                    Return Date
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    : {{ form.date }}
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    Attachment
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    : 
                    <ul v-if="form.attachment && form.attachment.length>0">
                        <li v-for="(item,index) in form.attachment" :key="index">
                            <a :href="item.url">{{ item.name_file }}</a>
                        </li>
                    </ul>
                </td>
            </tr>
        </table>

        <table width="100%" class="vs-table vs-table--tbody-table print">
            <thead class="vs-table--thead">
                <tr>
                    <th>
                        <div>SKU Code</div>
                    </th>
                    <th>
                        <div>SKU Description</div>
                    </th>
                    <th>SR Qty</th>
                    <th>Bad Stock Qty</th>
                    <th>Batch/ED</th>
                    <th>Return Qty</th>
                    <th>Remaining</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in form.lines" :key="index" style="padding-bottom: 5px">
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.item_unit.sku_code }}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.item_unit.item_name }}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.quantity }}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.quantity }}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ `${item.batch ?item.batch:'-'} / ${item.expired_date? formatDate(item.expired_date):"-"}`}}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.return_qty }}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.quantity - item.return_qty }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="flex justify-center w-full pt-6 print-button">
            <vs-button style="margin:'0 auto'" color="primary" @click="handlePrint()">Print</vs-button>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    components: {
    },
    mounted() {
        this.id = this.$route.params.id;
        this.mode = this.$route.params.mode;
        this.initData();
    },
    data() {
        return {
            dialog: {
                save: false,
            },
            id: null,
            checkOptions: [{
                value: 0,
                name: "Passed",
            }, {
                value: 1,
                name: "Damaged",
            }],
            attachment: null,
            form: {
                lines: [],
            },
        }
    },
    methods: {
        async handlePrint() {
            await window.print();
        },
        initData() {
            this.$http.get(`${this.$store.state.outbound.supplierReturn.baseUrlPath}/${this.id}`)
            .then((resp) => {
                if (resp.code == 200) {
                    this.form = resp.data;
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
    },
    computed: {
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
        formatDate: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format('DD MMM YYYY');
            };
        },
        formatLocalNumber: () => {
            return (val) => {
                return Number(val).toLocaleString("id-ID");
            };
        },
    },
}
</script>

<style>
/* Set the page size to A4 and the orientation to landscape */
@page {
    size: A4 landscape;
}

/* Set the font size to 12px for printing */
@media print {
    body {
        font-size: 12px;
        background: none !important;
    }

    * {
        background: none !important;
    }

    header,
    footer,
    .print-button,
    #content-area * :not(.content-wrapper *) {
        display: none !important;
        visibility: hidden !important;
    }

    .router-view,
    .router-content {
        padding: 0 !important;
        margin: 0 !important;
    }
}

table.print {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    margin-top: 20px;
}

table.print td,
table.print th {
    border: 1px solid #abab !important;
    text-align: left;
    padding: 8px;
}
</style>
